'use client'

import { useIsMobileOrTabletClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { getValue } from '@/lib/utils'
import { TCollectionDetail } from '@/types/collection'
import Image from 'next/image'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

type Props = {
  collection: TCollectionDetail
}

export const CollectionHeroBanner: React.FC<Props> = ({ collection }) => {
  const isMobile = useIsMobileOrTabletClient()
  const bannerDesktop = getValue(collection?.banner, 'desktop', '')
  const bannerMobile = getValue(collection?.banner, 'mobile', '')
  const href = getValue(collection?.banner, 'url', '')
  const searchParams = useSearchParams()

  const scrollToListing = searchParams.get('scroll_to_listing')

  useEffect(() => {
    if (scrollToListing) {
      const listingElement = document.getElementById('collection-listing')
      if (listingElement) {
        listingElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [scrollToListing, searchParams])

  if (!bannerDesktop && !bannerMobile) {
    return null
  }

  const handleClick = () => {
    if (href) {
      window.location.href = href
      return
    }

    // Scroll to collection listing if no href
    const listingElement = document.getElementById('collection-listing')
    if (listingElement) {
      listingElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section
      className='relative w-full cursor-pointer'
      aria-label='Hero Banner Slideshow'
      onClick={handleClick}
    >
      <section className='collection-banner w-full'>
        {/* <Link
          href={bannerDesktop}
          className='block h-full w-full'
          aria-label={`View promotion}`}
        > */}
        {isMobile ? (
          <div className='md:hidden'>
            <Image
              src={ImageHelper.getImageUrl(bannerMobile, 'm', 672, 990, 80)}
              alt={`Promotional banner - mobile view`}
              width={768}
              height={393}
              className='block h-auto object-cover md:hidden'
              priority={true}
              loading='eager'
              fetchPriority='high'
              sizes='(max-width: 768px) 100vw, 768px'
              quality={80}
            />
          </div>
        ) : (
          <div className='hidden md:block'>
            <Image
              src={ImageHelper.getImageUrl(bannerDesktop, '', 1920, 787, 80)}
              alt={`Promotional banner`}
              width={1920}
              height={787}
              className='hidden h-auto w-full object-cover md:block'
              priority={true}
              loading='eager'
              fetchPriority='high'
              sizes='(min-width: 769px) 100vw, 768px'
            />
          </div>
        )}

        {/* </Link> */}
      </section>
    </section>
  )
}
